import { Box, Container, Typography } from "@mui/material";
import React from "react";
import {
  colorApp,
  colorBg,
  colorBlack,
  textStyle,
  titleStyle,
} from "../../../Resources/Design/theme";

export default function Goals() {
  return (
    <Box sx={{ bgcolor: colorApp }}>
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          position: "relative",
          zIndex: 5,
          flexDirection: { xs: "column", sm: "row" },
          py: { xs: "60px", sm: "90px", md: "90px" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: { xs: "100%", sm: "100%" },
            textAlign: "left",
            mr: { xs: "0px", sm: "24px" },
          }}
        >
          <Typography sx={{ ...titleStyle, color: colorBg }}>
            Jaké jsou naše cíle?
          </Typography>
          <Typography
            sx={{
              ...textStyle,
              color: colorBg,
              mt: "14px",
              maxWidth: { xs: "100%", sm: "100%" },
            }}
          >
            Jedno z našich základních hesel je “Cesta je cíl”. To znamená, že se
            chceme soustředit na průběh a ne na konec. Nyní jsme ve fázi, kdy
            projekt vzniká. Provází ho porodní bolesti a jiné komplikace. To je
            však správně. Víme kde se zlepšovat. Jak už jsme zmínili, náš záměr
            je spojit lidi v kynologii a celou tuto sféru dělat příjemnější a
            propagovat ji novým lidem. S tím jsou spjaty naše plány tvořit
            kontent, ať už ve formě videí, článku aj. Můžete se tedy těšit na
            zábavný, edukativní a jiný obsah - nejvíce tedy na našem Youtube.
            Tímto pak vytvořit silnou komunitu lidí, kteří dokáží velké věci.
            Buďte toho součástí s námi.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
